<template>
  <ul class="ips__context_menu el-dropdown-menu el-popper">
    <!--<content-menu-item @click="removeCurrent()">-->
      <!--关闭当期-->
    <!--</content-menu-item>-->
    <li class="el-dropdown-menu__item" @click="removeCurrent()">
      关闭当前
    </li>
    <li class="el-dropdown-menu__item" @click="removeOther()">
      关闭其他
    </li>
    <li class="el-dropdown-menu__item" @click="removeAll()">
      关闭所有
    </li>
  </ul>
</template>

<script>
  import {bus} from '../index'
  export default {
    name: "contentMenu"
    , methods: {
      removeCurrent() {
        bus.$emit('remove-current')
      }
      , removeOther() {
        bus.$emit('remove-other')
      }
      , removeAll() {
        bus.$emit('remove-all')
      }
    }
  }
</script>

<style lang="scss">
  .ips__context_menu {
    display: none;

    &.active {
      display: block;
      position: fixed;
    }
  }
</style>